<div class="card">
  <div class="flex justify-between items-start mb-3 gap-2">
    <div class="w-full">
      <p class="text-xs text-grey-600 uppercase mb-1">Action</p>
      @if (!editing) {
        <h2 class="font-semibold text-lg">{{action.ActionDescription || 'Action description'}}</h2>
      }
      @if (editing) {
        <textarea
          pTextarea
          rows="3"
          class="w-full prime-input description-input"
          [ngClass]="{'p-invalid': descriptionError && descriptionError.length>0}"
          [(ngModel)]="action.ActionDescription"
          placeholder="Enter action description"></textarea>
        @if (descriptionError && descriptionError.length>0) {
          <p class="text-danger-base text-sm mt-1">{{descriptionError}}</p>
        }
      }
    </div>
    <div class="flex flex-col items-end gap-2">
      <p-tag [severity]="statusSeverity()" [value]="statusLabel()" [ngClass]="{'pill-closed': action.Resolved}"></p-tag>
      @if (action.Resolved && action.ResolvedDate) {
        <p class="text-xs text-grey-600">Resolved {{action.ResolvedDate | date:'dd MMM yyyy'}}</p>
      }
      <button pButton type="button" class="btn-inverse btn-compact btn-small" (click)="toggleResolved.emit()">
        <i class="pi" [ngClass]="action.Resolved ? 'pi-undo' : 'pi-check'"></i>
        <span class="ml-1">{{action.Resolved ? 'Reopen Action' : 'Resolve Action'}}</span>
      </button>
    </div>
  </div>

  <div class="grid grid-cols-1 gap-3">
    <div>
      <p class="label">Assigned To</p>
      @if (!editing) {
        <p class="readonly-field">{{selectedUser?.DisplayName || action.ActionAssignee || 'Unassigned'}}</p>
      }
      @if (editing) {
        <p-select
          [options]="users"
          [(ngModel)]="selectedUser"
          optionLabel="DisplayName"
          placeholder="Select user"
          (onChange)="onAssigneeChange($event.value)"
          class="w-full prime-input"
          [ngClass]="{'p-invalid': assigneeError && assigneeError.length>0}">
          <ng-template let-user pTemplate="item">
            <span [ngClass]="{'font-bold': user?.UserTypeID === 2}">{{user?.DisplayName}}</span>
          </ng-template>
          <ng-template let-user pTemplate="selectedItem">
            <span [ngClass]="{'font-bold': user?.UserTypeID === 2}">{{user?.DisplayName}}</span>
          </ng-template>
        </p-select>
        @if (assigneeError && assigneeError.length>0) {
          <p class="text-danger-base text-sm mt-1">{{assigneeError}}</p>
        }
      }
    </div>
    <div>
      <p class="label">Due Date</p>
      @if (!editing) {
        <p class="readonly-field">{{action.ActionDeadline | date:'dd MMM yyyy'}}</p>
      }
      @if (editing) {
        <p-datepicker
          [(ngModel)]="action.ActionDeadline"
          (ngModelChange)="onDeadlineChange($event)"
          dateFormat="dd M yy"
          [minDate]="minDate"
          [panelStyle]="{minWidth: '14rem', width: 'auto'}"
          class="date-input"
          [ngClass]="{'p-invalid': dateError && dateError.length>0}">
        </p-datepicker>
        @if (dateError && dateError.length>0) {
          <p class="text-danger-base text-sm mt-1">{{dateError}}</p>
        }
      }
    </div>
  </div>

  @if (!action.Resolved) {
    <div class="flex flex-wrap gap-2 mt-4">
      <button pButton type="button" class="btn-primary btn-compact btn-small" (click)="toggleEdit.emit()">
        <i class="pi" [ngClass]="editing ? 'pi-save' : 'pi-pencil'"></i>
        <span class="ml-1">{{editing ? 'Save' : 'Edit'}}</span>
      </button>
    </div>
  }
</div>
